<div class="container-fluid">
  <!-- Page Header -->
  <div class="row page-header-section">
    <div class="col s12">
      <div class="header">
        <div class="timesheet-header-content">
          <!-- Profile Image - Show when user is selected -->
          <div class="profile-image-wrapper"
            [class.profile-image-hidden]="!(timesheetMode === 'user' && (selectedValue || userData))">
            <img [src]="userData?.meta?.profile_image_url"
              *ngIf="timesheetMode === 'user' && userData?.meta?.profile_image_url && userData?.meta?.profile_image_url !== 'null' && userData?.meta?.profile_image_url !== null"
              class="timesheet-profile-image" alt="Profile" />
            <ngx-avatars
              *ngIf="timesheetMode === 'user' && userData && (!userData?.meta?.profile_image_url || userData?.meta?.profile_image_url === 'null' || userData?.meta?.profile_image_url === null)"
              name="{{ userData.name }}"></ngx-avatars>
          </div>
          <div class="timesheet-title-block">
            <h1>Timesheet Reports</h1>
            <span class="header-selected-user" *ngIf="timesheetMode === 'user' && (selectedValue || userData)">
              for {{ trimName((selectedValue?.name || userData?.name || '')) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Report View Section (Combined filters + results) -->
  <div class="row main-report-section">
    <div class="col s12">
      <div class="section-card main-report-card">
        <!-- Unified Filters Row -->
        <div class="filters-container">
          <div class="filters-unified-row">
            <!-- Date Controls -->
            <div class="filter-group-inline">
              <app-user-options [timesheetMode]="timesheetMode" [maxRangeDays]="timesheetMode === 'period' ? 31 : 90"
                [employeeList]="employeeList" [selectedUser]="selectedUser" [teamList]="teamList"
                [selectedTeamId]="selectedTeamId" [shiftList]="shiftList" [selectedShiftId]="selectedShiftId"
                [startDate]="startDate" [endDate]="endDate" [selectDate]="selectDate" [todayDate]="todayDate"
                (toggleChange)="isPersonalizesToggleChange($event)" (userSelection)="employeeSelected($event)"
                (teamSelection)="onTeamSelectionChange($event)" (shiftSelection)="onShiftSelectionChange($event)"
                (startDateChange)="onStartDateChange($event)" (endDateChange)="onEndDateChange($event)"
                (selectDateChange)="onSelectDateChange($event)">
              </app-user-options>
            </div>

            <!-- Day-wise / User-wise Toggle -->
            <div class="filter-group-inline">
              <div class="segmented-control-wrapper">
                <button class="segment" [class.active]="timesheetMode === 'day'"
                  (click)="setDayWise()">Day-wise</button>
                <button class="segment" [class.active]="timesheetMode === 'user'"
                  (click)="setUserWise()">User-wise</button>
                <button type="button" class="segment"
                  [class.active]="timesheetMode === 'period'"
                  [class.segment-locked]="isPeriodTimesheetLocked()"
                  (click)="setPeriodWise()"
                  [matTooltip]="isPeriodTimesheetLocked() ? 'Included in Professional — click to learn more' : ''"
                  matTooltipPosition="below">
                  <span>Period-wise</span>
                  <mat-icon *ngIf="isPeriodTimesheetLocked()" class="segment-lock-icon" fontSet="material-icons-outlined">lock</mat-icon>
                </button>
              </div>
            </div>

            <!-- Breakdown Controls -->
            <div class="filter-group-inline">
              <app-user-filter [timesheetMode]="timesheetMode" [isApplicationUsage]="isApplicationUsage"
                [isWebsiteUsage]="isWebsiteUsage" (toggleChange)="onToggleChange($event)" (export)="downloadAction()">
              </app-user-filter>
              <button *ngIf="timesheetMode === 'period' && canUsePeriodTimesheet()" type="button" class="absence-calendar-toggle"
                (click)="openAbsenceCalendarDialog()" matTooltip="Open absence insight for this period (shift-aware)"
                matTooltipPosition="above">
                <mat-icon fontSet="material-icons-outlined" class="absence-calendar-toggle-icon">event_busy</mat-icon>
                <span>Absence insight</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Report Context Summary -->
        <div class="report-context-summary" *ngIf="!loadWaiter">
          <div class="context-main">
            <span class="context-label">Showing:</span>
            <span class="context-value context-value-wrap" *ngIf="timesheetMode === 'day'"
              [attr.title]="getContextSummaryFullText()">Day-wise report for {{ datePipe.transform(selectDate, 'dd MMM
              yyyy') }}</span>
            <span class="context-value context-value-wrap" *ngIf="timesheetMode === 'period'"
              [attr.title]="getContextSummaryFullText()">{{ getContextSummaryFullText() }}</span>
            <span class="context-value context-value-wrap" *ngIf="timesheetMode === 'user' && selectedUser"
              [attr.title]="getContextSummaryFullText()">User-wise report for {{ userName?.replace("'s Timesheet", '')
              }} from {{ datePipe.transform(startDate, 'dd MMM yyyy') }} to {{ datePipe.transform(endDate, 'dd MMM
              yyyy') }}</span>
          </div>
          <div class="context-breakdown" *ngIf="isApplicationUsage || isWebsiteUsage">
            <span class="context-label">Breakdown:</span>
            <span class="context-value" *ngIf="isApplicationUsage">By App</span>
            <span class="context-value" *ngIf="isWebsiteUsage">By Website</span>
          </div>
        </div>

        <p class="timesheet-metric-hint" *ngIf="!loadWaiter">
          {{ timesheetMetricHint }}
        </p>
        <p class="timesheet-metric-hint period-absent-hint" *ngIf="!loadWaiter && timesheetMode === 'period'">
          {{ periodAbsentDaysHint }}
        </p>

        <!-- KPI Summary Cards -->
        <div class="kpi-cards-container" *ngIf="!loadWaiter && totalRowData">
          <div class="kpi-card kpi-productive">
            <div class="kpi-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 11L12 14L22 4" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div class="kpi-content">
              <div class="kpi-label">Usage Time</div>
              <div class="kpi-value">{{ totalRowData.productive || '00:00:00' }}</div>
            </div>
          </div>

          <div class="kpi-card kpi-idle">
            <div class="kpi-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
                <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
            </div>
            <div class="kpi-content">
              <div class="kpi-label">Idle Time</div>
              <div class="kpi-value">{{ totalRowData.idle || '00:00:00' }}</div>
            </div>
          </div>

          <div class="kpi-card kpi-offline">
            <div class="kpi-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
                <path d="M15 9L9 15M9 9L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
            </div>
            <div class="kpi-content">
              <div class="kpi-label kpi-label-with-info">
                <span>Offline Time</span>
                <mat-icon class="kpi-info-icon" fontSet="material-icons-outlined" role="img"
                  aria-label="About Offline Time" [matTooltip]="offlineTimeTooltip" matTooltipPosition="above"
                  matTooltipClass="timesheet-tracked-tooltip" (click)="$event.stopPropagation()">info_outline</mat-icon>
              </div>
              <div class="kpi-value">{{ totalRowData.offline || '00:00:00' }}</div>
            </div>
          </div>

          <div class="kpi-card kpi-total">
            <div class="kpi-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2" />
                <path d="M3 9H21M9 3V21" stroke="currentColor" stroke-width="2" />
              </svg>
            </div>
            <div class="kpi-content">
              <div class="kpi-label kpi-label-with-info">
                <span>Tracked Time</span>
                <mat-icon class="kpi-info-icon" fontSet="material-icons-outlined" role="img"
                  aria-label="About Tracked Time" [matTooltip]="trackedTimeTooltip" matTooltipPosition="above"
                  matTooltipClass="timesheet-tracked-tooltip" (click)="$event.stopPropagation()">info_outline</mat-icon>
              </div>
              <div class="kpi-value">{{ totalRowData.working || '00:00:00' }}</div>
            </div>
          </div>

          <div class="kpi-card kpi-idle" *ngIf="timesheetMode === 'period'">
            <div class="kpi-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2V6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path d="M12 18V22" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path d="M4.93 4.93L7.76 7.76" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path d="M16.24 16.24L19.07 19.07" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path d="M2 12H6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path d="M18 12H22" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path d="M4.93 19.07L7.76 16.24" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path d="M16.24 7.76L19.07 4.93" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
            </div>
            <div class="kpi-content">
              <div class="kpi-label kpi-label-with-info">
                <span>Overtime</span>
                <mat-icon class="kpi-info-icon" fontSet="material-icons-outlined" role="img" aria-label="About Overtime"
                  [matTooltip]="overtimeTimeTooltip" matTooltipPosition="above"
                  matTooltipClass="timesheet-tracked-tooltip" (click)="$event.stopPropagation()">info_outline</mat-icon>
              </div>
              <div class="kpi-value">{{ totalRowData.overtime || '00:00:00' }}</div>
            </div>
          </div>
        </div>

        <!-- Table Results -->
        <div class="table-container">
          <div class="list-parts">
            <table matSort (matSortChange)="sortData($event)" class="highlight centered" #dataTable>
              <thead>
                <tr class="table-head">
                  <ng-container *ngFor="let header of headers">
                    <th *ngIf="header.visible && header.key === 'working'" mat-sort-header="working"
                      [title]="header.fullLabel">
                      <span class="th-label-with-info">
                        {{ header.label }}
                        <mat-icon class="column-info-icon" fontSet="material-icons-outlined" role="img"
                          aria-label="About Tracked Time" [matTooltip]="trackedTimeTooltip" matTooltipPosition="above"
                          matTooltipClass="timesheet-tracked-tooltip"
                          (click)="$event.stopPropagation()">info_outline</mat-icon>
                      </span>
                    </th>
                    <th *ngIf="header.visible && header.key !== 'working'" [mat-sort-header]="header.key"
                      [title]="header.fullLabel">
                      {{ header.label }}
                    </th>
                  </ng-container>
                </tr>
              </thead>
              <tbody *ngIf="!loadWaiter">
                <tr *ngFor="let val of timelineList; let currentRow = index">
                  <ng-container *ngFor="let field of headers">
                    <td *ngIf="field.visible">
                      <ng-container *ngIf="field.key === 'name'; else nonNameCell">
                        <div class="timesheet-name-cell">
                          <button *ngIf="timesheetMode === 'period'" type="button"
                            class="period-employee-name-link" (click)="onPeriodEmployeeNameClick(val, $event)"
                            [attr.aria-label]="'View User-wise timesheet for ' + (val?.name || 'employee')"
                            matTooltip="Open User-wise breakdown (same date range)" matTooltipPosition="above">
                            {{ getFieldValue(val, field.key, currentRow) }}
                          </button>
                          <span *ngIf="timesheetMode !== 'period'">{{ getFieldValue(val, field.key, currentRow) }}</span>
                          <span
                            *ngIf="showRustAgentBetaBadge(val)"
                            class="agent-beta-badge agent-beta-badge--name"
                            [matTooltip]="sysConfig.rustAgentNameBadgeTooltip"
                            matTooltipPosition="below">{{ sysConfig.rustAgentBetaBadge }}</span>
                        </div>
                      </ng-container>
                      <ng-template #nonNameCell>
                        {{ getFieldValue(val, field.key, currentRow) }}
                      </ng-template>
                    </td>
                  </ng-container>
                </tr>
              </tbody>
              <tfoot *ngIf="!loadWaiter && totalRowData">
                <tr class="total-row">
                  <ng-container *ngFor="let field of headers">
                    <td *ngIf="field.visible">
                      <ng-container [ngSwitch]="field.key">
                        <ng-container *ngSwitchCase="'index'"></ng-container>
                        <ng-container *ngSwitchCase="'name'">{{ totalRowData.name || "Total" }}</ng-container>
                        <ng-container *ngSwitchCase="'date'">{{ timesheetMode === 'user' ? 'Total' : ''
                          }}</ng-container>
                        <ng-container *ngSwitchCase="'absent_days'">{{ totalRowData.absent_days }}</ng-container>
                        <ng-container *ngSwitchDefault>{{ totalRowData[field.key] != null && totalRowData[field.key] !==
                          '' ? totalRowData[field.key] : '-' }}</ng-container>
                      </ng-container>
                    </td>
                  </ng-container>
                </tr>
              </tfoot>
            </table>

            <div *ngIf="loadWaiter" class="skeleton-loader-container">
              <ngx-skeleton-loader count="6"
                [theme]="{ 'border-radius': '2', height: '50px', width: '100%' }"></ngx-skeleton-loader>
            </div>

            <div *ngIf="!loadWaiter && employeeList && !employeeList.length && !timelineList.length && !showExamplePreview" class="empty-list">
              <app-activation-data-state
                kind="thin"
                title="Collecting work hours"
                body="No hours for this filter yet. Values stay pending until SuperSee has tracked activity — not shown as 00:00.">
              </app-activation-data-state>
            </div>

            <app-example-preview-card
              *ngIf="showExamplePreview"
              variant="hours"
              [ownWorkdayReady]="ownWorkdayReady">
            </app-example-preview-card>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Bulk Export Section - Moved to Data Management Page -->
  <!-- <div class="row bulk-export-section">
    <div class="col s12">
      <div class="section-card bulk-export-card">
        <div class="section-header">
          <h2 class="section-title">Bulk Team Export</h2>
          <p class="section-help-text">Export team-wide report data for the selected date range. This export is separate from the report shown above.</p>
        </div>
        <div class="section-content">
          <app-export-timesheet></app-export-timesheet>
        </div>
      </div>
    </div>
  </div> -->
</div>